/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { ReactNode } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

//TODO: Add anywhere where date-pickers are used
const LocalizationProviderSetup: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      {children}
    </LocalizationProvider>
  );
};

export default LocalizationProviderSetup;
